import { KbChapterPage } from "@/components/kb/KbChapterPage";

export function Chapter034() {
  return <KbChapterPage slug="chapter-034" />;
}

(Chapter034 as unknown as { path: string }).path = "/theory-album/034";
